import React from 'react';
import styled from 'styled-components';
import PageBreak from '../layout/PageBreak';
import { useGlobalState } from '../stateProvider/StateProvider';
import Page from '../layout/Page';
import Col from '../layout/Col';
import { mapObj } from '../utility/functions';
import Title from '../forms/Title';
import Heading from '../forms/Heading';
import Preput from '../forms/Preput';
import Input from '../forms/Input';
import Pre from '../layout/Pre';
import Img from '../Img';
import HSLink from '../forms/HSLink';
import Card from '../forms/Card';
import { EmbedVideo } from '../HelpDesk';
import RoleProtected, { userRoles } from '../RoleProtected';
import Icon from '../forms/Icon';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';
import ModalFactory from '../Modal';

const Text = styled(Card)`
    max-width: 75%;
`

const AggregateTips = ({ ...props }) => {

    const {
        state: {
            pageInfo
        },
        getPageInfo
    } = useGlobalState();

    const updateHelp = (key) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: 'Delete Page?',
                body: `Are you sure you want to delete the page info for ${key}?`
            },
            promise: {
                title: 'Deleting',
                callback: () => HamQuest.delete(QuestRoute.pageInfo, { page: key }).then(() => getPageInfo())
            }
        })
    }

    return (
        <Col align='center' gap='2em'>
            {mapObj(pageInfo, ([key, value]) => (value.title || value.body.length > 0) ? (
                <Text gap='1.5em' key={key}>
                    <Title>
                        {(key !== 'user_page' && key !== 'loyalty_user') ? <HSLink to={'/' + key.replace(/_/g, '/')}>{value.title}</HSLink> : value.title}
                        {/* 
                        <RoleProtected roles={[userRoles.technicalInterfaceMaven]}>
                            <Icon
                                icon={'cross'}
                                style={{ fontSize: '0.8em' }}
                                onClick={() => updateHelp(key)}
                            />
                        </RoleProtected> 
                        */}
                    </Title>
                    {value.body.map((e, i) => (
                        <Col gap='1.5em' key={`info_` + i}>
                            {e.heading && <Heading fontSize='1.5'>{e.heading}</Heading>}
                            {e.text && <Pre>{e.text}</Pre>}
                            {e.image && <Img src={e.image} dim={15} style={{ width: '100%' }} />}
                            {e.video && <Col align='center'><EmbedVideo src={e.video} /></Col>}
                        </Col>
                    ))}
                </Text>
            ) : null)}
        </Col>
    );
}

export default AggregateTips;
